import { useEffect, useState } from "react";
import api from "../lib/api";
import CourseCard from "../components/CourseCard";
import { Heart } from "lucide-react";
import { Link } from "react-router-dom";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/wishlist").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="container-x py-12" data-testid="wishlist-page">
      <h1 className="font-display text-3xl tracking-tight">Your wishlist</h1>
      {items.length === 0 ? (
        <div className="mt-10 rounded-xl border border-dashed border-border p-16 text-center">
          <Heart className="h-8 w-8 mx-auto text-muted-foreground" />
          <div className="mt-4 font-display text-xl">No saved courses yet</div>
          <p className="text-sm text-muted-foreground mt-1">Tap the heart on any course to save it here for later.</p>
          <Link to="/marketplace" className="btn-primary inline-flex mt-6">Browse marketplace</Link>
        </div>
      ) : (
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((c) => <CourseCard key={c.id} course={c} />)}
        </div>
      )}
    </div>
  );
}
